export default {
  deviceOrientation(state) {
    return state.deviceOrientation;
  },

  deviceType(state) {
    return state.deviceType;
  },

  isMobile(state) {
    return state.isMobile;
  },

  isTablet(state) {
    return state.isTablet;
  },

  isDesktop(state) {
    return state.isDesktop;
  },
};
